import React from "react";

export const AppsLogo = () => {
	return (
		<svg
			width="18"
			height="18"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M9 22H15C16.66 22 18 20.66 18 19V5C18 3.34 16.66 2 15 2H9C7.34 2 6 3.34 6 5V19C6 20.66 7.34 22 9 22Z"
				fill="#4B5563"
			/>
			<path
				d="M4.5 5.93021V18.0702C4.5 18.3902 4.21 18.6202 3.9 18.5602C2.42 18.2902 2 17.4302 2 15.3302V8.67021C2 6.57021 2.42 5.71021 3.9 5.44021C4.21 5.38021 4.5 5.61021 4.5 5.93021Z"
				fill="#4B5563"
			/>
			<path
				d="M22 8.67021V15.3302C22 17.4302 21.58 18.2902 20.1 18.5602C19.79 18.6202 19.5 18.3802 19.5 18.0702V5.93021C19.5 5.61021 19.79 5.38021 20.1 5.44021C21.58 5.71021 22 6.57021 22 8.67021Z"
				fill="#4B5563"
			/>
		</svg>
	);
};

export const APICollectionsLogo = () => {
	return (
		<svg
			width="18"
			height="18"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M19.37 4.89012L13.51 2.28012C12.65 1.90012 11.35 1.90012 10.49 2.28012L4.62999 4.89012C3.14999 5.55012 2.92999 6.45012 2.92999 6.93012C2.92999 7.41012 3.14999 8.31012 4.62999 8.97012L10.49 11.5801C10.92 11.7701 11.46 11.8701 12 11.8701C12.54 11.8701 13.08 11.7701 13.51 11.5801L19.37 8.97012C20.85 8.31012 21.07 7.41012 21.07 6.93012C21.07 6.45012 20.86 5.55012 19.37 4.89012Z"
				fill="#4B5563"
			/>
			<path
				d="M12 17.04C11.62 17.04 11.24 16.96 10.89 16.81L4.15001 13.81C3.12001 13.35 2.32001 12.12 2.32001 10.99C2.32001 10.58 2.65001 10.25 3.06001 10.25C3.47001 10.25 3.80001 10.58 3.80001 10.99C3.80001 11.53 4.25001 12.23 4.75001 12.45L11.49 15.45C11.81 15.59 12.18 15.59 12.5 15.45L19.24 12.45C19.74 12.23 20.19 11.54 20.19 10.99C20.19 10.58 20.52 10.25 20.93 10.25C21.34 10.25 21.67 10.58 21.67 10.99C21.67 12.11 20.87 13.35 19.84 13.81L13.1 16.81C12.76 16.96 12.38 17.04 12 17.04Z"
				fill="#4B5563"
			/>
			<path
				d="M12 22C11.62 22 11.24 21.92 10.89 21.77L4.15001 18.77C3.04001 18.28 2.32001 17.17 2.32001 15.95C2.32001 15.54 2.65001 15.21 3.06001 15.21C3.47001 15.21 3.80001 15.54 3.80001 15.95C3.80001 16.58 4.17001 17.15 4.75001 17.41L11.49 20.41C11.81 20.55 12.18 20.55 12.5 20.41L19.24 17.41C19.81 17.16 20.19 16.58 20.19 15.95C20.19 15.54 20.52 15.21 20.93 15.21C21.34 15.21 21.67 15.54 21.67 15.95C21.67 17.17 20.95 18.27 19.84 18.77L13.1 21.77C12.76 21.92 12.38 22 12 22Z"
				fill="#4B5563"
			/>
		</svg>
	);
};

export const TemplatesLogo = () => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M7.33268 13.2666V2.73325C7.33268 1.73325 6.90602 1.33325 5.84602 1.33325H3.15268C2.09268 1.33325 1.66602 1.73325 1.66602 2.73325V13.2666C1.66602 14.2666 2.09268 14.6666 3.15268 14.6666H5.84602C6.90602 14.6666 7.33268 14.2666 7.33268 13.2666Z"
				fill="#4B5563"
			/>
			<path
				d="M14.3327 7.26659V2.73325C14.3327 1.73325 13.906 1.33325 12.846 1.33325H10.1527C9.09268 1.33325 8.66602 1.73325 8.66602 2.73325V7.26659C8.66602 8.26659 9.09268 8.66659 10.1527 8.66659H12.846C13.906 8.66659 14.3327 8.26659 14.3327 7.26659Z"
				fill="#4B5563"
			/>
			<path
				d="M14.3327 13.2667V11.4C14.3327 10.4 13.906 10 12.846 10H10.1527C9.09268 10 8.66602 10.4 8.66602 11.4V13.2667C8.66602 14.2667 9.09268 14.6667 10.1527 14.6667H12.846C13.906 14.6667 14.3327 14.2667 14.3327 13.2667Z"
				fill="#4B5563"
			/>
		</svg>
	);
};

export const UserProfileIcon = () => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
		>
			<rect width="24" height="24" rx="12" fill="url(#pattern0)" />
			<defs>
				<pattern
					id="pattern0"
					patternContentUnits="objectBoundingBox"
					width="1"
					height="1"
				>
					<use
						xlinkHref="#image0_914_60025"
						transform="translate(-0.00260417) scale(0.00520833)"
					/>
				</pattern>
				<image
					id="image0_914_60025"
					width="193"
					height="192"
					xlinkHref="data:image/png;base64,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"
				/>
			</defs>
		</svg>
	);
};

export const ArrowDownIcon = () => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M13.2797 5.9668L8.93306 10.3135C8.41973 10.8268 7.57973 10.8268 7.06639 10.3135L2.71973 5.9668"
				stroke="#6B7280"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const SingleProfileIcon = () => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8.10671 7.24683C8.04004 7.24016 7.96004 7.24016 7.88671 7.24683C6.30004 7.1935 5.04004 5.8935 5.04004 4.2935C5.04004 2.66016 6.36004 1.3335 8.00004 1.3335C9.63337 1.3335 10.96 2.66016 10.96 4.2935C10.9534 5.8935 9.69337 7.1935 8.10671 7.24683Z"
				stroke="#6B7280"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M4.77348 9.7065C3.16014 10.7865 3.16014 12.5465 4.77348 13.6198C6.60681 14.8465 9.61348 14.8465 11.4468 13.6198C13.0601 12.5398 13.0601 10.7798 11.4468 9.7065C9.62014 8.4865 6.61348 8.4865 4.77348 9.7065Z"
				stroke="#6B7280"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const SettingIcon = () => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
				stroke="#6B7280"
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 12.8801V11.1201C2 10.0801 2.85 9.22006 3.9 9.22006C5.71 9.22006 6.45 7.94006 5.54 6.37006C5.02 5.47006 5.33 4.30006 6.24 3.78006L7.97 2.79006C8.76 2.32006 9.78 2.60006 10.25 3.39006L10.36 3.58006C11.26 5.15006 12.74 5.15006 13.65 3.58006L13.76 3.39006C14.23 2.60006 15.25 2.32006 16.04 2.79006L17.77 3.78006C18.68 4.30006 18.99 5.47006 18.47 6.37006C17.56 7.94006 18.3 9.22006 20.11 9.22006C21.15 9.22006 22.01 10.0701 22.01 11.1201V12.8801C22.01 13.9201 21.16 14.7801 20.11 14.7801C18.3 14.7801 17.56 16.0601 18.47 17.6301C18.99 18.5401 18.68 19.7001 17.77 20.2201L16.04 21.2101C15.25 21.6801 14.23 21.4001 13.76 20.6101L13.65 20.4201C12.75 18.8501 11.27 18.8501 10.36 20.4201L10.25 20.6101C9.78 21.4001 8.76 21.6801 7.97 21.2101L6.24 20.2201C5.33 19.7001 5.02 18.5301 5.54 17.6301C6.45 16.0601 5.71 14.7801 3.9 14.7801C2.85 14.7801 2 13.9201 2 12.8801Z"
				stroke="#6B7280"
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const HelpCenterIcon = () => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M17 18.43H13L8.54999 21.39C7.88999 21.83 7 21.36 7 20.56V18.43C4 18.43 2 16.43 2 13.43V7.42993C2 4.42993 4 2.42993 7 2.42993H17C20 2.42993 22 4.42993 22 7.42993V13.43C22 16.43 20 18.43 17 18.43Z"
				stroke="#6B7280"
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.0001 11.36V11.15C12.0001 10.47 12.4201 10.11 12.8401 9.82001C13.2501 9.54001 13.66 9.18002 13.66 8.52002C13.66 7.60002 12.9201 6.85999 12.0001 6.85999C11.0801 6.85999 10.3401 7.60002 10.3401 8.52002"
				stroke="#6B7280"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11.9955 13.75H12.0045"
				stroke="#6B7280"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const LogoutIcon = () => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8.8999 7.55999C9.2099 3.95999 11.0599 2.48999 15.1099 2.48999H15.2399C19.7099 2.48999 21.4999 4.27999 21.4999 8.74999V15.27C21.4999 19.74 19.7099 21.53 15.2399 21.53H15.1099C11.0899 21.53 9.2399 20.08 8.9099 16.54"
				stroke="#6B7280"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M15.0001 12H3.62012"
				stroke="#6B7280"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5.85 8.65002L2.5 12L5.85 15.35"
				stroke="#6B7280"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const GoogleIcon = () => {
	return (
		<svg
			width="25"
			height="24"
			viewBox="0 0 25 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M21.9632 10.3915H21.2059V10.3529H12.7353V14.1176H18.0552C17.2776 16.3088 15.193 17.8823 12.7353 17.8823C9.61581 17.8823 7.08824 15.3548 7.08824 12.2353C7.08824 9.1158 9.61581 6.58822 12.7353 6.58822C14.1746 6.58822 15.4853 7.1305 16.4816 8.01837L19.1434 5.35661C17.4632 3.79043 15.2151 2.82352 12.7353 2.82352C7.53677 2.82352 3.32353 7.03675 3.32353 12.2353C3.32353 17.4338 7.53677 21.647 12.7353 21.647C17.9338 21.647 22.1471 17.4338 22.1471 12.2353C22.1471 11.6048 22.0827 10.989 21.9632 10.3915Z"
				fill="#FFC107"
			/>
			<path
				d="M4.40809 7.85477L7.50184 10.1232C8.33824 8.05146 10.364 6.58822 12.7353 6.58822C14.1746 6.58822 15.4853 7.1305 16.4816 8.01837L19.1434 5.35661C17.4632 3.79043 15.2151 2.82352 12.7353 2.82352C9.11949 2.82352 5.98529 4.86396 4.40809 7.85477Z"
				fill="#FF3D00"
			/>
			<path
				d="M12.7353 21.647C15.1654 21.647 17.375 20.7169 19.046 19.204L16.1324 16.739C15.1875 17.454 14.0129 17.8823 12.7353 17.8823C10.2868 17.8823 8.20956 16.3217 7.42647 14.1434L4.35662 16.5073C5.91361 19.5551 9.07721 21.647 12.7353 21.647Z"
				fill="#4CAF50"
			/>
			<path
				d="M21.9632 10.3915H21.2059V10.3529H12.7353V14.1176H18.0552C17.682 15.1709 17.0037 16.0772 16.1305 16.739C16.1324 16.739 16.1324 16.739 16.1324 16.739L19.046 19.204C18.8401 19.3897 22.1471 16.9412 22.1471 12.2353C22.1471 11.6048 22.0827 10.989 21.9632 10.3915Z"
				fill="#1976D2"
			/>
		</svg>
	);
};

export const VerifyMailIcon = () => {
	return (
		<svg
			width="80"
			height="80"
			viewBox="0 0 80 80"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect width="80" height="80" rx="40" fill="#E8F5FF" />
			<path
				d="M28 42C22.48 42 18 46.46 18 52C18 57.54 22.48 62 28 62C33.52 62 38 57.52 38 52C38 46.48 33.54 42 28 42ZM23.92 47.92H28C28.76 47.92 29.36 48.54 29.36 49.28C29.36 50.02 28.74 50.64 28 50.64H23.92C23.16 50.64 22.56 50.02 22.56 49.28C22.56 48.54 23.16 47.92 23.92 47.92ZM32.08 56.08H23.9C23.14 56.08 22.54 55.46 22.54 54.72C22.54 53.98 23.16 53.36 23.9 53.36H32.08C32.84 53.36 33.44 53.98 33.44 54.72C33.44 55.46 32.84 56.08 32.08 56.08Z"
				fill="#036FE3"
			/>
			<path
				opacity="0.4"
				d="M50 22H30C24 22 20 25 20 32V38.28C20 39.74 21.5 40.66 22.84 40.08C25.04 39.12 27.54 38.76 30.16 39.18C35.4 40.04 39.68 44.18 40.74 49.38C41.04 50.9 41.08 52.38 40.88 53.8C40.72 54.98 41.68 56.02 42.86 56.02H50C56 56.02 60 53.02 60 46.02V32.02C60 25 56 22 50 22Z"
				fill="#036FE3"
			/>
			<path
				d="M40 39.74C38.32 39.74 36.6201 39.22 35.3201 38.16L29.06 33.16C28.42 32.64 28.3001 31.7 28.8201 31.06C29.3401 30.42 30.28 30.3 30.92 30.82L37.18 35.82C38.7 37.04 41.28 37.04 42.8 35.82L49.06 30.82C49.7 30.3 50.66 30.4 51.16 31.06C51.68 31.7 51.58 32.66 50.92 33.16L44.66 38.16C43.38 39.22 41.68 39.74 40 39.74Z"
				fill="#036FE3"
			/>
		</svg>
	);
};

export const ForgotPasswordIcon = () => {
	return (
		<svg
			width="80"
			height="80"
			viewBox="0 0 80 80"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect width="80" height="80" rx="40" fill="#E8F5FF" />
			<path
				opacity="0.4"
				d="M57.8202 38.24C57.8202 48.02 50.7202 57.18 41.0202 59.86C40.3602 60.04 39.6402 60.04 38.9802 59.86C29.2802 57.18 22.1802 48.02 22.1802 38.24V29.46C22.1802 27.82 23.4202 25.96 24.9602 25.34L36.1002 20.78C38.6002 19.76 41.4202 19.76 43.9202 20.78L55.0602 25.34C56.5802 25.96 57.8402 27.82 57.8402 29.46L57.8202 38.24Z"
				fill="#036FE3"
			/>
			<path
				d="M45 37C45 34.24 42.76 32 40 32C37.24 32 35 34.24 35 37C35 39.24 36.48 41.1 38.5 41.74V47C38.5 47.82 39.18 48.5 40 48.5C40.82 48.5 41.5 47.82 41.5 47V41.74C43.52 41.1 45 39.24 45 37Z"
				fill="#036FE3"
			/>
		</svg>
	);
};

export const CheckMailIcon = () => {
	return (
		<svg
			width="80"
			height="80"
			viewBox="0 0 80 80"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect width="80" height="80" rx="40" fill="#E8F5FF" />
			<path
				d="M55 32C57.7614 32 60 29.7614 60 27C60 24.2386 57.7614 22 55 22C52.2386 22 50 24.2386 50 27C50 29.7614 52.2386 32 55 32Z"
				fill="#036FE3"
			/>
			<path
				d="M55 32C57.7614 32 60 29.7614 60 27C60 24.2386 57.7614 22 55 22C52.2386 22 50 24.2386 50 27C50 29.7614 52.2386 32 55 32Z"
				fill="#036FE3"
			/>
			<path
				opacity="0.4"
				d="M57.44 34.62C58.7 34.22 60 35.2 60 36.54V47.02C60 54.02 56 57.02 50 57.02H30C24 57.02 20 54.02 20 47.02V33.02C20 26.02 24 23.02 30 23.02H45.22C46.52 23.02 47.4 24.22 47.16 25.48C46.92 26.66 46.96 27.92 47.32 29.22C48.06 31.9 50.24 34.04 52.92 34.74C54.5 35.14 56.04 35.06 57.44 34.62Z"
				fill="#036FE3"
			/>
			<path
				d="M40 41.74C38.32 41.74 36.6201 41.22 35.3201 40.16L29.06 35.16C28.42 34.64 28.3001 33.7 28.8201 33.06C29.3401 32.42 30.28 32.3001 30.92 32.8201L37.18 37.8201C38.7 39.0401 41.28 39.0401 42.8 37.8201L45.16 35.94C45.8 35.42 46.7601 35.52 47.2601 36.18C47.7801 36.82 47.6801 37.78 47.0201 38.28L44.66 40.16C43.38 41.22 41.68 41.74 40 41.74Z"
				fill="#036FE3"
			/>
		</svg>
	);
};

export const ResetPasswordIcon = () => {
	return (
		<svg
			width="80"
			height="80"
			viewBox="0 0 80 80"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect width="80" height="80" rx="40" fill="#E8F5FF" />
			<path
				opacity="0.4"
				d="M57.8197 38.24C57.8197 48.02 50.7197 57.18 41.0197 59.86C40.3597 60.04 39.6397 60.04 38.9797 59.86C29.2797 57.18 22.1797 48.02 22.1797 38.24V29.46C22.1797 27.82 23.4197 25.96 24.9597 25.34L36.0997 20.78C38.5997 19.76 41.4197 19.76 43.9197 20.78L55.0597 25.34C56.5797 25.96 57.8397 27.82 57.8397 29.46L57.8197 38.24Z"
				fill="#036FE3"
			/>
			<path
				d="M45 37C45 34.24 42.76 32 40 32C37.24 32 35 34.24 35 37C35 39.24 36.48 41.1 38.5 41.74V47C38.5 47.82 39.18 48.5 40 48.5C40.82 48.5 41.5 47.82 41.5 47V41.74C43.52 41.1 45 39.24 45 37Z"
				fill="#036FE3"
			/>
		</svg>
	);
};

export const SearchIcon = () => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M9.58334 17.4998C13.9556 17.4998 17.5 13.9554 17.5 9.58317C17.5 5.21092 13.9556 1.6665 9.58334 1.6665C5.21108 1.6665 1.66667 5.21092 1.66667 9.58317C1.66667 13.9554 5.21108 17.4998 9.58334 17.4998Z"
				stroke="#6B7280"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M18.3333 18.3332L16.6667 16.6665"
				stroke="#6B7280"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const GridIcon = () => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 14 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.8333 4.96984V2.3215C12.8333 1.499 12.46 1.1665 11.5325 1.1665H9.17583C8.24833 1.1665 7.875 1.499 7.875 2.3215V4.964C7.875 5.79234 8.24833 6.119 9.17583 6.119H11.5325C12.46 6.12484 12.8333 5.79234 12.8333 4.96984Z"
				stroke="#111827"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.8333 11.5325V9.17583C12.8333 8.24833 12.46 7.875 11.5325 7.875H9.17583C8.24833 7.875 7.875 8.24833 7.875 9.17583V11.5325C7.875 12.46 8.24833 12.8333 9.17583 12.8333H11.5325C12.46 12.8333 12.8333 12.46 12.8333 11.5325Z"
				stroke="#111827"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.12484 4.96984V2.3215C6.12484 1.499 5.7515 1.1665 4.824 1.1665H2.46734C1.53984 1.1665 1.1665 1.499 1.1665 2.3215V4.964C1.1665 5.79234 1.53984 6.119 2.46734 6.119H4.824C5.7515 6.12484 6.12484 5.79234 6.12484 4.96984Z"
				stroke="#111827"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.12484 11.5325V9.17583C6.12484 8.24833 5.7515 7.875 4.824 7.875H2.46734C1.53984 7.875 1.1665 8.24833 1.1665 9.17583V11.5325C1.1665 12.46 1.53984 12.8333 2.46734 12.8333H4.824C5.7515 12.8333 6.12484 12.46 6.12484 11.5325Z"
				stroke="#111827"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const ListIcon = () => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 14 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M1.75 2.3335H12.25" stroke="#6B7280" strokeLinecap="round" />
			<path d="M1.75 7H12.25" stroke="#6B7280" strokeLinecap="round" />
			<path d="M1.75 11.6665H12.25" stroke="#6B7280" strokeLinecap="round" />
		</svg>
	);
};

export const HorizontalDotsMenuIcon = () => {
	return (
		<svg
			width="14"
			height="14"
			viewBox="0 0 14 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M2.91667 5.83301C2.275 5.83301 1.75 6.35801 1.75 6.99967C1.75 7.64134 2.275 8.16634 2.91667 8.16634C3.55833 8.16634 4.08333 7.64134 4.08333 6.99967C4.08333 6.35801 3.55833 5.83301 2.91667 5.83301Z"
				fill="#6B7280"
			/>
			<path
				d="M11.0833 5.83301C10.4417 5.83301 9.91667 6.35801 9.91667 6.99967C9.91667 7.64134 10.4417 8.16634 11.0833 8.16634C11.725 8.16634 12.25 7.64134 12.25 6.99967C12.25 6.35801 11.725 5.83301 11.0833 5.83301Z"
				fill="#6B7280"
			/>
			<path
				d="M6.99999 5.83301C6.35833 5.83301 5.83333 6.35801 5.83333 6.99967C5.83333 7.64134 6.35833 8.16634 6.99999 8.16634C7.64166 8.16634 8.16666 7.64134 8.16666 6.99967C8.16666 6.35801 7.64166 5.83301 6.99999 5.83301Z"
				fill="#6B7280"
			/>
		</svg>
	);
};

export const CloseModalIcon = () => {
	return (
		<svg
			width="18"
			height="18"
			viewBox="0 0 18 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M14.25 4.8075L13.1925 3.75L9 7.9425L4.8075 3.75L3.75 4.8075L7.9425 9L3.75 13.1925L4.8075 14.25L9 10.0575L13.1925 14.25L14.25 13.1925L10.0575 9L14.25 4.8075Z"
				fill="#111827"
			/>
		</svg>
	);
};

export const VerificationIcon = () => {
	return (
		<svg
			width="80"
			height="80"
			viewBox="0 0 80 80"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect width="80" height="80" rx="40" fill="#EAF9E8" />
			<path
				opacity="0.4"
				d="M40 60C51.0457 60 60 51.0457 60 40C60 28.9543 51.0457 20 40 20C28.9543 20 20 28.9543 20 40C20 51.0457 28.9543 60 40 60Z"
				fill="#008539"
			/>
			<path
				d="M37.1609 47.16C36.7609 47.16 36.3809 47 36.1009 46.72L30.4409 41.06C29.8609 40.48 29.8609 39.52 30.4409 38.94C31.0209 38.36 31.9809 38.36 32.5609 38.94L37.1609 43.54L47.4409 33.26C48.0209 32.68 48.9809 32.68 49.5609 33.26C50.1409 33.84 50.1409 34.8 49.5609 35.38L38.2209 46.72C37.9409 47 37.5609 47.16 37.1609 47.16Z"
				fill="#008539"
			/>
		</svg>
	);
};

export const CopyIcon = () => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10.6673 8.59992V11.3999C10.6673 13.7333 9.73398 14.6666 7.40065 14.6666H4.60065C2.26732 14.6666 1.33398 13.7333 1.33398 11.3999V8.59992C1.33398 6.26659 2.26732 5.33325 4.60065 5.33325H7.40065C9.73398 5.33325 10.6673 6.26659 10.6673 8.59992Z"
				fill="white"
			/>
			<path
				d="M11.3998 1.33325H8.59984C6.67914 1.33325 5.71152 1.97018 5.42907 3.49252C5.32748 4.04009 5.79484 4.49992 6.35175 4.49992H7.39984C10.1998 4.49992 11.4998 5.79992 11.4998 8.59992V9.64802C11.4998 10.2049 11.9597 10.6723 12.5072 10.5707C14.0296 10.2882 14.6665 9.32062 14.6665 7.39992V4.59992C14.6665 2.26659 13.7332 1.33325 11.3998 1.33325Z"
				fill="white"
			/>
		</svg>
	);
};

export const CaretDownIcon = () => {
	return (
		<svg
			width="12"
			height="12"
			viewBox="0 0 12 12"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M9.96004 4.47461L6.70004 7.73461C6.31504 8.11961 5.68504 8.11961 5.30004 7.73461L2.04004 4.47461"
				stroke="#4B5563"
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const XRemoveIcon = () => {
	return (
		<svg
			width="18"
			height="18"
			viewBox="0 0 18 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M14.25 4.8075L13.1925 3.75L9 7.9425L4.8075 3.75L3.75 4.8075L7.9425 9L3.75 13.1925L4.8075 14.25L9 10.0575L13.1925 14.25L14.25 13.1925L10.0575 9L14.25 4.8075Z"
				fill="#111827"
			/>
		</svg>
	);
};

export const EmptyGroupIcon = () => {
	return (
		<svg
			width="64"
			height="64"
			viewBox="0 0 64 64"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				opacity="0.4"
				d="M56.1079 19.1759L32.0012 33.1226L7.89453 19.1759C8.9612 17.2026 10.5079 15.4693 12.2412 14.5093L26.4812 6.61594C29.5212 4.90927 34.4812 4.90927 37.5212 6.61594L51.7612 14.5093C53.4945 15.4693 55.0412 17.2026 56.1079 19.1759Z"
				fill="#036FE3"
			/>
			<path
				opacity="0.6"
				d="M32.0017 33.1185V58.6652C30.0017 58.6652 28.0017 58.2385 26.4817 57.3852L12.2417 49.4919C9.015 47.7052 6.375 43.2252 6.375 39.5452V24.4519C6.375 22.7452 6.96167 20.8785 7.895 19.1719L32.0017 33.1185Z"
				fill="#036FE3"
			/>
			<path
				d="M57.6281 24.4519V39.5452C57.6281 43.2252 54.9881 47.7052 51.7615 49.4919L37.5215 57.3852C36.0015 58.2385 34.0015 58.6652 32.0015 58.6652V33.1185L56.1081 19.1719C57.0415 20.8785 57.6281 22.7452 57.6281 24.4519Z"
				fill="#036FE3"
			/>
		</svg>
	);
};

export const EmptyCallIcon = () => {
	return (
		<svg
			width="64"
			height="64"
			viewBox="0 0 64 64"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				opacity="0.4"
				d="M53.5992 18.5092C53.5992 19.9492 52.8259 21.2558 51.5992 21.9225L46.9591 24.4291L43.0125 26.5359L34.8258 30.9625C33.9458 31.4425 32.9859 31.6826 31.9992 31.6826C31.0125 31.6826 30.0525 31.4425 29.1725 30.9625L12.3992 21.9225C11.1725 21.2558 10.3992 19.9492 10.3992 18.5092C10.3992 17.0692 11.1725 15.7625 12.3992 15.0958L17.6525 12.2692L21.8392 10.0026L29.1725 6.05594C30.9325 5.09594 33.0658 5.09594 34.8258 6.05594L51.5992 15.0958C52.8259 15.7625 53.5992 17.0692 53.5992 18.5092Z"
				fill="#036FE3"
			/>
			<path
				opacity="0.4"
				d="M26.3993 34.1024L10.7993 26.2891C9.59932 25.6758 8.21267 25.7558 7.066 26.4491C5.91933 27.1425 5.25269 28.3692 5.25269 29.7025V44.4491C5.25269 47.0091 6.66598 49.3025 8.95931 50.4491L24.5593 58.2359C25.0927 58.5026 25.6794 58.6358 26.266 58.6358C26.9594 58.6358 27.6527 58.4492 28.266 58.0492C29.4127 57.3559 30.0793 56.1291 30.0793 54.7958V40.0492C30.106 37.5426 28.6927 35.2491 26.3993 34.1024Z"
				fill="#036FE3"
			/>
			<path
				opacity="0.4"
				d="M58.7462 29.7351V44.4816C58.7462 47.015 57.3329 49.3083 55.0396 50.4549L39.4395 58.2683C38.9062 58.5349 38.3195 58.6683 37.7328 58.6683C37.0395 58.6683 36.3462 58.4817 35.7062 58.0817C34.5862 57.3884 33.8928 56.1616 33.8928 54.8283V40.1083C33.8928 37.5483 35.3062 35.2549 37.5995 34.1083L43.3328 31.2549L47.3328 29.2549L53.1995 26.3216C54.3995 25.7083 55.7862 25.7616 56.9329 26.4816C58.0529 27.175 58.7462 28.4017 58.7462 29.7351Z"
				fill="#036FE3"
			/>
			<path
				d="M60.2664 57.7008L58.2397 55.6742C59.3064 54.0742 59.9198 52.1541 59.9198 50.1007C59.9198 44.4741 55.3597 39.9141 49.7331 39.9141C44.1064 39.9141 39.5464 44.4741 39.5464 50.1007C39.5464 55.7274 44.1064 60.2874 49.7331 60.2874C51.7864 60.2874 53.7064 59.6741 55.3064 58.6074L57.3331 60.6341C57.7331 61.0341 58.2664 61.2474 58.7997 61.2474C59.3331 61.2474 59.8664 61.0341 60.2664 60.6341C61.0664 59.8074 61.0664 58.5008 60.2664 57.7008Z"
				fill="#036FE3"
			/>
		</svg>
	);
};

export const PencilEditIcon = () => {
	return (
		<svg
			width="14"
			height="14"
			viewBox="0 0 14 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M3.23166 11.3828C2.87583 11.3828 2.54333 11.2603 2.30416 11.0328C2.00083 10.747 1.85499 10.3153 1.90749 9.84866L2.12333 7.95866C2.16416 7.60283 2.37999 7.13033 2.63083 6.87366L7.41999 1.8045C8.61583 0.538663 9.86416 0.503663 11.13 1.6995C12.3958 2.89533 12.4308 4.14366 11.235 5.4095L6.44583 10.4787C6.20083 10.7412 5.74583 10.9862 5.38999 11.0445L3.51166 11.3653C3.41249 11.3712 3.32499 11.3828 3.23166 11.3828ZM9.29249 1.69366C8.84333 1.69366 8.45249 1.97366 8.05583 2.39366L3.26666 7.46866C3.14999 7.59116 3.01583 7.88283 2.99249 8.052L2.77666 9.942C2.75333 10.1345 2.79999 10.292 2.90499 10.3912C3.00999 10.4903 3.16749 10.5253 3.35999 10.4962L5.23833 10.1753C5.40749 10.1462 5.68749 9.9945 5.80416 9.872L10.5933 4.80283C11.3167 4.03283 11.5792 3.32116 10.5233 2.3295C10.0567 1.88033 9.65416 1.69366 9.29249 1.69366Z"
				fill="#6B7280"
			/>
			<path
				d="M10.115 6.38587C10.1033 6.38587 10.0858 6.38587 10.0741 6.38587C8.25414 6.20503 6.78997 4.82253 6.50997 3.0142C6.47497 2.77503 6.6383 2.55337 6.87747 2.51253C7.11664 2.47753 7.3383 2.64087 7.37914 2.88003C7.6008 4.2917 8.74414 5.3767 10.1675 5.5167C10.4066 5.54003 10.5816 5.75587 10.5583 5.99503C10.5291 6.2167 10.3366 6.38587 10.115 6.38587Z"
				fill="#6B7280"
			/>
			<path
				d="M12.25 13.2734H1.75C1.51083 13.2734 1.3125 13.0751 1.3125 12.8359C1.3125 12.5968 1.51083 12.3984 1.75 12.3984H12.25C12.4892 12.3984 12.6875 12.5968 12.6875 12.8359C12.6875 13.0751 12.4892 13.2734 12.25 13.2734Z"
				fill="#6B7280"
			/>
		</svg>
	);
};

export const SuccessCheckIcon = () => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1ZM11.0234 5.71406L7.73281 10.2766C7.68682 10.3408 7.62619 10.3931 7.55595 10.4291C7.48571 10.4652 7.40787 10.4841 7.32891 10.4841C7.24994 10.4841 7.17211 10.4652 7.10186 10.4291C7.03162 10.3931 6.97099 10.3408 6.925 10.2766L4.97656 7.57656C4.91719 7.49375 4.97656 7.37813 5.07812 7.37813H5.81094C5.97031 7.37813 6.12187 7.45469 6.21562 7.58594L7.32812 9.12969L9.78438 5.72344C9.87813 5.59375 10.0281 5.51562 10.1891 5.51562H10.9219C11.0234 5.51562 11.0828 5.63125 11.0234 5.71406Z"
				fill="white"
			/>
		</svg>
	);
};

export const DeleteIcon = () => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M14.0466 3.48732C12.9733 3.38065 11.8999 3.30065 10.8199 3.24065V3.23398L10.6733 2.36732C10.5733 1.75398 10.4266 0.833984 8.86661 0.833984H7.11994C5.56661 0.833984 5.41994 1.71398 5.31328 2.36065L5.17328 3.21398C4.55328 3.25398 3.93328 3.29398 3.31328 3.35398L1.95328 3.48732C1.67328 3.51398 1.47328 3.76065 1.49994 4.03398C1.52661 4.30732 1.76661 4.50732 2.04661 4.48065L3.40661 4.34732C6.89994 4.00065 10.4199 4.13398 13.9533 4.48732C13.9733 4.48732 13.9866 4.48732 14.0066 4.48732C14.2599 4.48732 14.4799 4.29398 14.5066 4.03398C14.5266 3.76065 14.3266 3.51398 14.0466 3.48732Z"
				fill="white"
			/>
			<path
				d="M12.82 5.42602C12.66 5.25935 12.44 5.16602 12.2134 5.16602H3.7867C3.56004 5.16602 3.33337 5.25935 3.18004 5.42602C3.0267 5.59268 2.94004 5.81935 2.95337 6.05268L3.3667 12.8927C3.44004 13.906 3.53337 15.1727 5.86004 15.1727H10.14C12.4667 15.1727 12.56 13.9127 12.6334 12.8927L13.0467 6.05935C13.06 5.81935 12.9734 5.59268 12.82 5.42602ZM9.1067 11.8327H6.8867C6.61337 11.8327 6.3867 11.606 6.3867 11.3327C6.3867 11.0593 6.61337 10.8327 6.8867 10.8327H9.1067C9.38004 10.8327 9.6067 11.0593 9.6067 11.3327C9.6067 11.606 9.38004 11.8327 9.1067 11.8327ZM9.6667 9.16602H6.33337C6.06004 9.16602 5.83337 8.93935 5.83337 8.66602C5.83337 8.39268 6.06004 8.16602 6.33337 8.16602H9.6667C9.94004 8.16602 10.1667 8.39268 10.1667 8.66602C10.1667 8.93935 9.94004 9.16602 9.6667 9.16602Z"
				fill="white"
			/>
		</svg>
	);
};

export const TemplateUnoSVG = () => {
	return (
		<svg
			width="60"
			height="80"
			viewBox="0 0 60 80"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_2576_130631)">
				<path
					d="M29.5788 38.976V36.9237C29.5788 25.5941 16.332 16.4138 0.0195312 16.4138V59.4859C0.0195312 70.8155 13.2621 80 29.5788 80C45.8955 80 59.1381 70.8155 59.1381 59.4859C59.1381 48.1562 45.9124 38.976 29.5788 38.976Z"
					fill="#F2F5F9"
				/>
				<path
					d="M29.5811 59.4901V61.5381C39.9058 61.5381 49.0058 65.2077 54.28 70.7691C57.3626 67.5302 59.1615 63.6537 59.1615 59.4859C59.1615 48.1562 45.9147 38.9718 29.6022 38.9718V36.9195C29.6022 25.5899 16.3555 16.4096 0.0429688 16.4096V38.9718C16.3344 38.976 29.5811 48.1605 29.5811 59.4901Z"
					fill="#EDF3FA"
				/>
				<path
					d="M59.1592 0C42.8214 0 29.6 9.18448 29.6 20.5141V59.4901C29.6 67.091 23.6459 73.7039 14.8203 77.251C19.5275 79.0982 24.5433 80.0326 29.6 80.0042C45.9336 80.0042 59.1592 70.8197 59.1592 59.4901V0Z"
					fill="#E6EDF5"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2576_130631">
					<rect width="59.1608" height="80" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};
